<template>
  <!-- 用户ip捕捉记录 -->
  <div class="logIp">
    <!-- 面包屑导航 -->
    <crumbs-bar :crumbsList="['日志管理', $route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          clearable
          style="width: 200px; margin-right: 5px"
          v-model="searchForm.start"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          clearable
          v-model="searchForm.end"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 200px; margin-right: 5px"
          placeholder="截至日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入用户编号"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="EntID"
        show-overflow-tooltip
        label="机构编号"
      >
      </el-table-column>
      <el-table-column
        prop="username"
        align="center"
        show-overflow-tooltip
        label="账号"
      >
      </el-table-column>
      <el-table-column
        prop="businesscode"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>

      <el-table-column
        prop="Addr"
        label="访问IP"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Port"
        label="端口"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="RecordDate"
        label="时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "logIp",
  data() {
    return {
      /**表格数据 */
      //机构编号	账号	主机IP	访问IP	端口	时间
      tableData: [
        {
          organNum: "机构编号",
          user: "账号",
          hostIp: "主机IP",
          assessIp: "访问IP",
          port: "端口",
          time: "时间",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        start: "",
        end: "",
        name: "",
      },
    };
  },
  components: {},
  mounted() {
    this.searchForm.start = this.$theMonthFirstOnDay(); // 默认查询本月的，查询太多了会卡
    this.searchForm.end = this.$theMonthFirstOnDay();
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetUserIPList",
        mindate: this.searchForm.start,
        maxdate: this.searchForm.end,
        username: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Pc_Log"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "function/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => {
              item.RecordDate =
                item.RecordDate.split(" ")[0] + " " + item.RecordTime;
              return item;
            });
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    // 导出数据
    exportData() {
      let data = {
        type: "Pc_GetUserIPList",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        mindate: this.searchForm.start,
        maxdate: this.searchForm.end,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Pc_Log";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=用户IP捕捉记录";
    },
  },
};
</script>

<style scoped>
.logIp {
  width: 100%;
  height: 100%;
}
</style>
